import { TIconFromRenderingParams } from '../../../../types/types';

export type TCalenderEvent = {
  calendarUrl: string;
  calendarIcon: TIconFromRenderingParams;
  calendarTitle: string;
  calendarDownload: boolean;
};

export enum TSaveCalendarEventButtonType {
  SECONDARYBLACK = 'secondary-black',
  PRIMARY = 'primary-btn',
  SMALL = 'small-btn',
  PRIMARYWHITE = 'primary-white'
}

export type TSaveCalendarEventProps = {
  calendarDetails: TCalenderEvent[];
  buttonType: TSaveCalendarEventButtonType;
  startDate?: string;
  endDate?: string;
  extraClassName?: string;
};
